export enum PayPalEcStatesEnum {
  underwriting_required = 'underwriting_required',
  in_progress = 'in_progress',
  email_not_confirmed = 'email_not_confirmed',
  completed = 'completed',
  restricted = 'restricted',
  unlinked = 'unlinked',
}
